import { FocusMonitor } from "@angular/cdk/a11y";
import { ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, forwardRef } from "@angular/core";
import { Component } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatFormFieldControl } from "@angular/material/form-field";
import { AUTOCOMPETE_CHIPS_STYLES, ModelAutocompleteChipsComponent } from "@app/evaluation/components/model-autocomplete/model-autocomplete-chips-component";
import { SearchRequest, SearchResponse, TastingEventService } from "@core/data";
import { TastingEvent } from "@core/data/types/tastings-event";
import { Observable } from "rxjs";

@Component({
    selector: 'pv-tasting-event-autocomplete-chips',
    templateUrl: './tasting-event-autocomplete-chips.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TastingEventAutocompleteChipsComponent),
            multi: true
        },
        {
            provide: MatFormFieldControl,
            useExisting: TastingEventAutocompleteChipsComponent
        }
    ],
    styles: [AUTOCOMPETE_CHIPS_STYLES]
})
export class TastingEventAutocompleteChipsComponent extends ModelAutocompleteChipsComponent<TastingEvent> {
    constructor(
        protected fm: FocusMonitor,
        protected elRef: ElementRef<HTMLElement>,
        protected _changeDetect: ChangeDetectorRef,
        private _tastingEventService: TastingEventService
    ){
        super(fm, elRef, _changeDetect);
    }

    search(search: SearchRequest): Observable<SearchResponse<TastingEvent>> {
        return this._tastingEventService.search(search);
    }
}